<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Muestra que no hay resultados</p>
    <ol>
      <li>Permite establecer título y subtítulo</li>
      <li>Si no se establece una de las propiedades, será por defecto: "Aún no hay registros"</li>
      <li>Tener en cuenta que el subtítulo se muestra primero.</li>
      <li>No permite cambiar el icono.</li>
    </ol>
    <PCShowNoResults
      title="No tienes alertas pendientes de lectura"
      subtitle="Aún no hay alertas pendientes."
    />
  </f7-block>
</template>

<script>
import PCShowNoResults from '@/components/common/PCShowNoResults.vue';

export default {
  name: 'TestPCShowNoResults',
  components: {
    PCShowNoResults,
  },
};
</script>
